import { render, staticRenderFns } from "./BillsForm.vue?vue&type=template&id=02667346&scoped=true"
import script from "./BillsForm.vue?vue&type=script&lang=js"
export * from "./BillsForm.vue?vue&type=script&lang=js"
import style0 from "./BillsForm.vue?vue&type=style&index=0&id=02667346&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02667346",
  null
  
)

export default component.exports